export default {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  api: {
    HOST: '/api'
  }
};

